// extracted by mini-css-extract-plugin
module.exports = {"bp-desktop-medium-viewport":"(min-width: 1280px)","desktop":"markdown-toc_desktop__XJu7U","narrow":"markdown-toc_narrow__ErCJb"};